<ll-titulo>Planificación</ll-titulo>
<plan-personal-predefinido-profesor [planificacionId]="planificacionId"></plan-personal-predefinido-profesor>
